import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalDepositDeleteProps {}

const ModalDepositDelete = ({}: ModalDepositDeleteProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    invoice: { setInvoice },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteDeposits');
  const onClose = () => {
    closeSingleModal('deleteDeposits');
    setInvoice('selected.deposit', -1);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Remover depósito"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Export.Deposit.Delete />
    </Modal>
  );
};

export default ModalDepositDelete;
